// action
import {
    GET_PINCODE_DETAIL,
    GET_PINCODE_DETAIL_FAIL,
    GET_PINCODE_DETAIL_SUCCESS,
    GET_PINCODE_DETAIL_RESET
} from '../action/getPincodeDetailAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PINCODE_DETAIL:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_PINCODE_DETAIL_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_PINCODE_DETAIL_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data,
            }
        case GET_PINCODE_DETAIL_RESET:
            return initialState
        default:
            return state
    }
}